import * as api from '../../api'
import * as types from '../../mutation-types'
import router from '../../../router'

const state = {
  contact: [],
  contacts: []
}

const getters = {
  singleContact: state => state.contact,
  allContacts: state => state.contacts
}

const actions = {
  getContacts ({ commit, rootGetters }) {
    api.instance.get(rootGetters.scopedSiteId + '/contacts')
      .then(function (response) {
        const contacts = response.data.contacts
        commit(types.RECEIVE_CONTACTS, contacts)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getContact ({ commit, rootGetters }, contactId) {
    api.instance.get(rootGetters.scopedSiteId + '/contacts/' + contactId)
      .then(function (response) {
        const contact = response.data.contact
        commit(types.RECEIVE_CONTACT, contact)
      })
  },
  addEditContact ({ commit, rootGetters }, contact) {
    if (contact.name !== '') {
      if (contact.phone_number !== '' || contact.email !== '') {
        if (contact.contact_id === 0) {
          api.instance.post(rootGetters.scopedSiteId + '/contacts', contact)
            .then(function (response) {
              if (response.data.success === 'true') {
                contact.contact_id = response.data.contact[0].contact_id
                commit(types.ADD_CONTACT, contact)

                router.push({ name: 'AdminContactsIndex' })
              } else {
                alert(response.data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          api.instance.put(rootGetters.scopedSiteId + '/contacts/' + contact.contact_id, contact)
            .then(function (response) {
              if (response.data.success === 'true') {
                commit(types.EDIT_CONTACT, contact)
                router.push({ name: 'AdminContactsIndex' })
              } else {
                alert(response.data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      } else {
        alert('Phone number or Email is required')
      }
    } else {
      alert('Name is required')
    }
  },
  deleteContact ({ commit, rootGetters }, contact) {
    api.instance.delete(rootGetters.scopedSiteId + '/contacts/' + contact.contact_id)
      .then(function (response) {
        commit(types.DELETE_CONTACT, contact)
      })
  }
}

const mutations = {
  [types.RECEIVE_CONTACTS] (state, contacts) {
    state.contacts = contacts
  },
  [types.RECEIVE_CONTACT] (state, contact) {
    state.contact = contact
  },
  [types.ADD_CONTACT] (state, contact) {
    state.contacts.push(contact)
  },
  [types.EDIT_CONTACT] (state, contact) {
    let contactToEdit = state.contacts.find(
      function (ele) {
        if (ele.contact_id === contact.contact_id) {
          return true
        }
      }
    )
    let index = state.contacts.indexOf(contactToEdit)
    state.contacts[index] = contact
  },
  [types.DELETE_CONTACT] (state, contact) {
    let contactToDelete = state.contacts.find(
      function (ele) {
        if (ele.contact_id === contact.contact_id) {
          return true
        }
      }
    )
    let index = state.contacts.indexOf(contactToDelete)
    state.contacts.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
